module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand10-bafb9457fe1a29fd82de70dba7a1489d.jpg";